import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { fetchDataFromApi } from "../utils/api";
const TermsAndConditions = () => {
  const [value, setValue] = useState("");
  const getData = async () => {
    let res = await fetchDataFromApi("/pages/one", {
      name: "terms-conditions",
    });
    setValue(res?.data?.html);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="max-w-4xl mx-auto p-4 py-10 md:py-20 text-justify">
      <div dangerouslySetInnerHTML={{ __html: value }} />
    </div>
  );
};

export default TermsAndConditions;
